import { render, staticRenderFns } from "./diagSupervise.vue?vue&type=template&id=0d960074&scoped=true&"
import script from "./diagSupervise.vue?vue&type=script&lang=js&"
export * from "./diagSupervise.vue?vue&type=script&lang=js&"
import style0 from "./diagSupervise.vue?vue&type=style&index=0&id=0d960074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d960074",
  null
  
)

export default component.exports